<template>
  <div class="progress" :style="computedStyleOuter">
    <div class="progress__container" :style="computedStyleInner">
      <div class="progress__indicator-container-ie11">
        <svg
          class="progress__indicator"
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            class="progress__outer-circle--ie11"
            :class="status"
            d="M119 60C119 92.5848 92.5848 119 60 119C27.4152 119 1 92.5848 1 60C1 27.4152 27.4152 1 60 1C92.5848 1 119 27.4152 119 60Z"
            fill="transparent"
            stroke="#00629b"
            stroke-width="2"
          />
        </svg>
      </div>
      <svg
        class="progress__indicator"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g class="progress__outer-circle-group">
          <path
            class="progress__outer-circle"
            :class="status"
            d="M119 60C119 92.5848 92.5848 119 60 119C27.4152 119 1 92.5848 1 60C1 27.4152 27.4152 1 60 1C92.5848 1 119 27.4152 119 60Z"
            fill="transparent"
            stroke="#48A23F"
            stroke-width="2"
          />
        </g>
        <g>
          <circle
            class="progress__inner-circle"
            :class="status"
            cx="60"
            cy="60"
            r="50"
            fill="#48A23F"
          />
          <path
            class="progress__mark"
            :class="status"
            d="M35.8633 68.1663L47.7805 78.6201L85.5184 45.5166"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
      <!-- <v-btn
        style="display: block; margin: 0 auto;"
        @click="status == 'pending' ? (status = 'success') : (status = 'pending')"
        >test</v-btn
      > -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressResponse',
  data() {
    return {
      thisComponent: {},
      outerCircleGroup: {},
      outerCircle: {},
      innerCircle: {},
      mark: {}
    };
  },
  props: {
    status: {
      type: String,
      default: () => 'pending', // "pending", "success", todo: "failure", "warning"
    },
    size: {
      type: Number,
      default: () => 120,
    },
  },
  watch: {
    status: function(status, oldStatus) {
      if(this.$logger && typeof(this.$logger)!=='undefined'){
        this.$logger.debug(`${oldStatus} => ${status}`);
      }
      if (oldStatus === 'pending' && status === 'success') {
        this.innerCircle.style.animation = 'anim-inner-circle 1s ease both';
        this.mark.style.animation = 'anim-mark 1s ease both 0.5s';
        const self = this;
        const listener = this.outerCircle.addEventListener('animationiteration', function(event) {
          self.outerCircle.style.animationPlayState = 'paused';
          self.outerCircleGroup.style.animationPlayState = 'paused';
          self.outerCircle.removeEventListener('animationiteration', listener);
        });
      } else if (oldStatus === 'success' && status === 'pending') {
        this.innerCircle.style.animation = 'anim-inner-circle-reverse 1s ease both 0.5s';
        this.mark.style.animation = 'anim-mark-reverse 1s ease both';
        this.outerCircle.style.animationIterationCount = this.outerCircleGroup.style.animationIterationCount =
          'infinite';
        this.outerCircle.style.animationPlayState = this.outerCircleGroup.style.animationPlayState =
          'running';
      }
    },
  },
  mounted: function() {
    this.thisComponent = this.$el;
    this.outerCircleGroup = this.thisComponent.querySelector('.progress__outer-circle-group');
    this.outerCircle = this.thisComponent.querySelector('.progress__outer-circle');
    this.innerCircle = this.thisComponent.querySelector('.progress__inner-circle');
    this.mark = this.thisComponent.querySelector('.progress__mark');

    if(this.status === "success"){
      this.outerCircle.style.animation = "none";
    }
  },
  computed: {
    computedStyleInner() {
      if(this.size && this.size !== this.$options.props.size.default()){
        let scale = this.size / this.$options.props.size.default();
        return `transform: scale(${scale.toString()}); transform-origin: top;`;
      } else {
        return '';
      }
    },
    computedStyleOuter() {
      if(this.size && this.size !== this.$options.props.size.default()){
        return `height: ${this.size}px;`;
      } else {
        return '';
      }
    }
  } 
};
</script>

<style lang="scss">
.progress {
  position: relative;
  margin: 24px 0 32px;

  &__indicator-container-ie11 {
    display: none;
    position: absolute;
    text-align: center;
    width: 100%;
    height: 120px;
    margin: 0 auto;
    transform-origin: center center;
    animation: anim-outer-circle-group 3s linear infinite;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      display: block;
    }

    .progress__indicator {
      display: inline;

      .progress__outer-circle--ie11 {
        stroke-dasharray: 370.7601013183594px;
        stroke-dashoffset: 100px;
        stroke: #00629b;
        opacity: 1;
        transition: all 1s;

        &.success {
          opacity: 0;
          stroke: #48a23f;
        }
        &.failure {
          opacity: 0;
          stroke: #d32f2f;
        }
        &.warning {
          opacity: 0;
          stroke: #e46f1f;
        }
      }
    }
  }

  &__outer-circle-group {
    animation: anim-outer-circle-group 3s linear normal both infinite;
    transform-origin: center center;
  }

  &__outer-circle {
    stroke: #00629b;
    transition: stroke 1s;
    stroke-dasharray: 370.7601013183594px;
    stroke-dashoffset: 0;
    transform-origin: center center;
    animation: anim-outer-circle 2s ease-in-out normal both infinite;

    &.success {
      stroke: #48a23f;
    }
    &.failure {
      stroke: #d32f2f;
    }
    &.warning {
      stroke: #e46f1f;
    }
    &.pending {
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        display: none;
      }
    }
  }
  &__inner-circle {
    r: 0;
    opacity: 0;
    
    &.success, &.failure, &.warning {
      r: 50;
      opacity: 1;
    }
  }
  &__mark {
    stroke-dasharray: 66.05200958251953px;
    stroke-dashoffset: 66.05200958251953px;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      stroke-dasharray: none;
    }

    &.success, &.failure, &.warning {
      stroke-dasharray: none;
    }
  }
}

@keyframes anim-outer-circle-group {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes anim-outer-circle {
  from {
    stroke-dashoffset: 0px;
  }
  to {
    stroke-dashoffset: -740px;
    //transform: rotate(50.7601013183594deg);
  }
}

@keyframes anim-inner-circle {
  from {
    r: 0;
    opacity: 0;
  }
  to {
    r: 50;
    opacity: 1;
  }
}

@keyframes anim-inner-circle-reverse {
  from {
    r: 50;
    opacity: 1;
  }
  to {
    r: 0;
    opacity: 0;
  }
}

@keyframes anim-mark {
  from {
    stroke-dashoffset: 66.05200958251953px;
    opacity: 0;
  }
  to {
    stroke-dashoffset: 0;
    opacity: 1;
  }
}

@keyframes anim-mark-reverse {
  from {
    stroke-dashoffset: 0;
    opacity: 1;
  }
  to {
    stroke-dashoffset: -66.05200958251953px;
    opacity: 0;
  }
}
</style>
